var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pr-4 lg:pr-8 pl-2 md:mr-8 lg:hidden focus:outline-none",on:{"click":_vm.toggleMobileNavbar}},[_c('i',{staticClass:"far fa-lg align-middle fa-fw fa-bars"})])
}
var staticRenderFns = []

export { render, staticRenderFns }